{
  "authority": "https://unbar-rothon-auth.osmm.devtank.co.uk",
  "client_id": "osm-portal",
  "client_secret": "v6fCdRbiWpMUtDF7h3FfylV5obxVHVBN",
  "apiUrl": "https://unbar-rothon-portal.osmm.devtank.co.uk/internal",
  "dbApi": "https://unbar-rothon-portal.osmm.devtank.co.uk/api",
  "dbToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiY3VzdG9tZXIifQ.i5gCvMMOd6vSZ1eiQCZ5jkPvS0FElwDdf8RwSj1-4KM"
}
